import React from 'react';
import logo from './logo.svg';
import './App.scss';
import { Header } from './components/interface/Header';
import { Footer } from './components/interface/Footer';
import { Router } from './core/Router';
import content from './content/content.json';
import EventDispatcher from './core/EventDispatcher';

function replaceBase (content)
{
	let base = document.querySelector('base').getAttribute('href');
	if(base == '--base--'){
		base = '/';
		document.querySelector('base').setAttribute('href', base);
	}
	content = JSON.stringify(content);
	content = content.replace(/\-\-base\-\-/ig, base);
	return JSON.parse(content);
}


export const GLOBAL:{
	content:any,
	router: Router
} = {
	content: replaceBase(content),
	router: null,
}


export const GlobalDispatcher = new EventDispatcher();

function App() {
	return (
		<div className="App">
			<Header></Header>
			<main>
				<Router content={replaceBase(content)}></Router>
			</main>
			<Footer></Footer>
		</div>
	);
}

export default App;
